export default {
	'展位信息确认':'1st Booth Infomation Confirmation',
	'展位基本信息':'2nd Basic information of booth',
	'承建商信息':'3rd Builder Information',
	'审图资料上传':'4th Upload Map Review Data',
	'地毯颜色选择':'Carpet color selection',
	'车证申请':'Car License Apply',
	'施工证申请':'Application for Construction Certificate',
	'报图结束':'End of Newspaper Map',
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawings.js